export enum WithdrawRequestStatus {
  NEW = 'NEW',
  WITHDRAWN = 'WITHDRAWN',
  CANCELED_BY_USER = 'CANCELED_BY_USER',
  CANCELED_BY_ADMIN = 'CANCELED_BY_ADMIN',
}
